<template>
  <div class="content-slide-item" v-if="active">
    <slot :item="item"></slot>
  </div>
</template>

<script>
export default {
  name: 'SlideItem',
  props: {
    item: {
      type: [Object, String, Number],
      default: null,
    },
  },
  data() {
    return {
      active: false,
    };
  },
};
</script>

<style scoped></style>
